<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <v-icon>mdi-format-align-justify</v-icon>
            <v-toolbar-title class="toolbar-title-2">{{riHeaderDisplay}} RI Headers</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              v-bind:headers="riHeaderColumns"
              v-bind:items="riHeaderItems"
              :server-items-length="totalItemsRI"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRIHeaders"
              item-key="key"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr :class="{ activeRow: selectedRecord == row.item.riType + '-' + row.item.riCoDesc + '-' + row.item.acctNoSfxWithDesc }" @dblclick="doEdit(row.item)">
                  <td class="text-xs-left">{{ getRIType(row.item.riType).label }}</td>
                  <td class="text-xs-left">{{ row.item.riType === 'D' ? 'STAT' : row.item.riCoDesc }}</td>
                  <td class="text-xs-left">{{ row.item.acctNoSfxWithDesc }}</td>
                  <td class="text-xs-left">{{ row.item.cesEndtCnt }}</td>
                  <td class="text-xs-left">{{ row.item.propXlDesc }}</td>
                  <td class="text-xs-left">{{ row.item.comDateDisp }}</td>
                  <td class="text-xs-left">{{ row.item.expDateDisp }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doEdit(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card id="riFormCard">
          <v-toolbar dense color="grey lighten-5" flat>
            <div class="v-icon mdi mdi-leaf theme--light d-flex">
              <span class="headerTitle-b"
                >{{riHeaderDisplay}} RI Header
                <span class="caption grey--text font-weight-light">(Query)</span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="showRiForm = !showRiForm">
              <v-icon primary v-if="showRiForm">mdi-chevron-down</v-icon>
              <v-icon primary v-else>mdi-chevron-up</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="showRiForm">
            <v-layout row wrap>
              <v-flex xs6 md6 lg4>
                <v-autocomplete
                  v-model="riForm.riType"
                  v-validate="'required'"
                  :items="riTypeList"
                  :label="labels.riType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riType"
                  :error-messages="errors.collect('riType')"
                  :data-vv-as="labels.riType"
                  :disabled="true"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-autocomplete
                  v-model="riForm.cesEndtCnt"
                  v-validate="'required'"
                  :items="cessEndtList"
                  :label="labels.cesEndtCnt"
                  item-text="text"
                  item-value="value"
                  data-vv-name="cesEndtCnt"
                  :error-messages="errors.collect('cesEndtCnt')"
                  :data-vv-as="labels.cesEndtCnt"
                  @change="getDetails()"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <span class="caption grey--text font-weight-light">(Note: Change CessEndt count to view previous records).</span>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  :disabled="true"
                  v-model="riForm.riCoDesc"
                  v-validate="'required'"
                  :label="labels.riCo"
                  data-vv-name="riCo"
                  :data-vv-as="labels.riCo"
                  :error-messages="errors.collect('riCo')"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon v-if="riForm.riType !== undefined" color="info" @click="doShowRiCo" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-autocomplete
                  :disabled="true"
                  v-model="riForm.propXl"
                  v-validate="'required'"
                  :items="proplXolList"
                  :label="labels.propXl"
                  item-text="label"
                  item-value="value"
                  data-vv-name="propXl"
                  :error-messages="errors.collect('propXl')"
                  :data-vv-as="labels.propXl"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  :disabled="true"
                  v-model="riForm.acctNoSfxWithDesc"
                  v-validate="'required'"
                  :label="labels.acctNoSfx"
                  data-vv-name="acctNoSfx"
                  :data-vv-as="labels.acctNoSfx"
                  :error-messages="errors.collect('acctNoSfx')"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon
                      v-if="riForm.riType === 'F' || riForm.riType === 'C'"
                      @click="doShowAcctNoSfx"
                      color="info"
                      v-text="'mdi-magnify'"
                    ></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  :disabled="true"
                  v-model="riForm.theirPolNo"
                  :label="labels.theirPolNo"
                  :data-vv-as="labels.theirPolNo"
                  v-validate="'entry'"
                  data-vv-name="theirPolNo"
                  :error-messages="errors.collect('theirPolNo')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.cesNo"
                  :label="labels.cesNo"
                  :data-vv-as="labels.cesNo"
                  v-validate="'entry'"
                  data-vv-name="cesNo"
                  :error-messages="errors.collect('cesNo')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.cesYr"
                  :label="labels.cesYr"
                  :data-vv-as="labels.cesYr"
                  v-validate="'entry'"
                  data-vv-name="cesYr"
                  :error-messages="errors.collect('cesYr')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.docNo"
                  :label="labels.docNo"
                  :data-vv-as="labels.docNoNo"
                  v-validate="'entry'"
                  data-vv-name="docNoNo"
                  :error-messages="errors.collect('docNoNo')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.cesEndtNo"
                  :label="labels.cesEndtNo"
                  :data-vv-as="labels.cesEndtNo"
                  v-validate="'entry'"
                  data-vv-name="cesEndtNo"
                  :error-messages="errors.collect('cesEndtNo')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.cesStamp"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="labels.cesStamp"
                  :data-vv-as="labels.cesStamp"
                  v-validate="'entry'"
                  data-vv-name="cesStamp"
                  :error-messages="errors.collect('cesStamp')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-checkbox
                  left
                  color="primary"
                  v-model="riForm.bordEreAux"
                  :label="labels.bordEreAux"
                  @change="bordEreAuxChanged"
                  :disabled="true"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-checkbox left color="primary" v-model="riForm.prtRiApp" :label="labels.prtRiApp" :disabled="true"></v-checkbox>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-checkbox left color="primary" v-model="riForm.relRi" :label="labels.relRi" :disabled="true"></v-checkbox>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <cal-picker
                  v-model="riForm.tranDate"
                  v-validate="'required'"
                  :label="labels.tranDate"
                  :data-vv-as="labels.tranDate"
                  data-vv-name="tranDate"
                  :error-messages="errors.collect('tranDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6 lg4>
                <cal-picker
                  v-model="riForm.riComDate"
                  v-validate="comDateValidation"
                  :label="labels.riComDate"
                  :data-vv-as="labels.riComDate"
                  data-vv-name="riComDate"
                  :error-messages="errors.collect('riComDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6 lg4>
                <cal-picker
                  v-model="riForm.riExpDate"
                  v-validate="expDateValidation"
                  :label="labels.riExpDate"
                  :data-vv-as="labels.riExpDate"
                  data-vv-name="riExpDate"
                  :error-messages="errors.collect('riExpDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6 lg4>
                <cal-picker
                  v-model="riForm.riEndtDate"
                  :label="labels.riEndtDate"
                  :data-vv-as="labels.riEndtDate"
                  data-vv-name="riEndtDate"
                  :error-messages="errors.collect('riEndtDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6 lg4>
                <v-text-field v-model="riForm.billCurr" :label="labels.billCurr" :disabled="true"></v-text-field>
              </v-flex>
              <v-flex xs12 md6 lg4> </v-flex>
              <v-flex xs6 md6 lg4>
                <v-layout row wrap>
                  <v-flex lg1>
                    <v-checkbox left color="primary" v-model="riForm.comm1AE" :disabled="true"></v-checkbox>
                  </v-flex>
                  <v-flex lg8>
                    <v-text-field
                      v-model="riForm.comm1Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                      :label="labels.comm1Pct"
                      :data-vv-as="labels.comm1Pct"
                      v-validate="'required'"
                      data-vv-name="comm1Pct"
                      :error-messages="errors.collect('comm1Pct')"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-layout row wrap>
                  <v-flex xs2 md1 lg1>
                    <v-checkbox left color="primary" v-model="riForm.comm2AE" :disabled="true"></v-checkbox>
                  </v-flex>
                  <v-flex xs5 md6 lg6>
                    <v-text-field
                      v-model="riForm.comm2Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                      :label="labels.comm2Pct"
                      :data-vv-as="labels.comm2Pct"
                      v-validate="'required'"
                      data-vv-name="comm2Pct"
                      :error-messages="errors.collect('comm2Pct')"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 md5 lg5>
                    <v-autocomplete
                      v-model="riForm.comm2Gn"
                      v-validate="'required'"
                      :items="grossNetList"
                      :label="labels.comm2Gn"
                      item-text="label"
                      item-value="value"
                      data-vv-name="comm2Gn"
                      :error-messages="errors.collect('comm2Gn')"
                      :data-vv-as="labels.comm2Gn"
                      :disabled="true"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-layout row wrap>
                  <v-flex xs2 md1 lg1>
                    <v-checkbox left color="primary" v-model="riForm.comm3AE" :disabled="true"></v-checkbox>
                  </v-flex>
                  <v-flex xs5 md6 lg6>
                    <v-text-field
                      v-model="riForm.comm3Pct"
                      v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                      :label="labels.comm3Pct"
                      :data-vv-as="labels.comm3Pct"
                      v-validate="'required'"
                      data-vv-name="comm3Pct"
                      :error-messages="errors.collect('comm3Pct')"
                      :disabled="true"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs5 md5 lg5>
                    <v-autocomplete
                      v-model="riForm.comm3Gn"
                      v-validate="'required'"
                      :items="grossNetList"
                      :label="labels.comm3Gn"
                      item-text="label"
                      item-value="value"
                      data-vv-name="comm3Gn"
                      :error-messages="errors.collect('comm3Gn')"
                      :data-vv-as="labels.comm3Gn"
                      :disabled="true"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.stampDuty"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="labels.stampDuty"
                  :data-vv-as="labels.stampDuty"
                  v-validate="'entry'"
                  data-vv-name="stampDuty"
                  :error-messages="errors.collect('stampDuty')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.riTax"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="labels.riTax"
                  :data-vv-as="labels.riTax"
                  v-validate="'entry'"
                  data-vv-name="riTax"
                  :error-messages="errors.collect('riTax')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.riLevy"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  :label="labels.riLevy"
                  :data-vv-as="labels.riLevy"
                  v-validate="'entry'"
                  data-vv-name="riLevy"
                  :error-messages="errors.collect('riLevy')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 lg4>
                <cal-picker
                  v-model="riForm.relDate"
                  :label="labels.relDate"
                  :data-vv-as="labels.relDate"
                  data-vv-name="relDate"
                  :error-messages="errors.collect('relDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <v-text-field
                  v-model="riForm.relUsr"
                  :label="labels.relUsr"
                  :data-vv-as="labels.relUsr"
                  data-vv-name="relUsr"
                  :error-messages="errors.collect('relUsr')"
                  :disabled="true"
                ></v-text-field>
              </v-flex>
              <transition name="slide-y-transition" mode="out-in">
                <v-flex xs12 v-if="!riForm.bordEreAux">
                  <v-card>
                    <v-toolbar dense color="grey lighten-5" flat>
                      <v-icon>mdi-format-align-justify</v-icon>
                      <v-toolbar-title class="toolbar-title-3">Contract Certainty</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4>
                          <cal-picker
                            v-model="riForm.ccaDate"
                            :label="labels.ccaDate"
                            :data-vv-as="labels.ccaDate"
                            data-vv-name="ccaDate"
                            :error-messages="errors.collect('ccaDate')"
                            :disabled="true"
                          />
                        </v-flex>
                        <v-flex xs6 md6 lg4>
                          <cal-picker
                            v-model="riForm.ccdDate"
                            :label="labels.ccdDate"
                            :data-vv-as="labels.ccdDate"
                            data-vv-name="ccdDate"
                            :error-messages="errors.collect('ccdDate')"
                            :disabled="true"
                          />
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4 v-if="riForm.ccDateEntUsr">
                          <v-subheader class="queryLabel">{{ labels.ccDateEntUsr }}</v-subheader>
                          <div class="queryValue">{{ riForm.ccDateEntUsr }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="riForm.ccDateRevUsr">
                          <v-subheader class="queryLabel">{{ labels.ccDateRevUsr }}</v-subheader>
                          <div class="queryValue">{{ riForm.ccDateRevUsr }}</div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </transition>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-spacer class="mt-1"></v-spacer>
        <v-card>
          <v-toolbar dense color="grey lighten-5" flat>
            <div class="v-icon mdi mdi-format-list-bulleted theme--light d-flex">
              <span class="headerTitle-b">{{riHeaderDisplay}} RI Text</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="showRiText = !showRiText">
              <v-icon primary v-if="showRiText">mdi-chevron-down</v-icon>
              <v-icon primary v-else>mdi-chevron-up</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="showRiText">
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-tabs v-model="riAppTxtTabMenu" slider-color="teal">
                    <v-tab ripple :key="1">{{ labels.riAppTxt }}</v-tab>
                    <v-tab ripple :key="2">{{ labels.riAppEndtTxt }}</v-tab>
                    <v-tabs-items v-model="riAppTxtTabMenu" touchless>
                      <v-tab-item :key="1">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea
                                  v-model="riForm.riAppTxt"
                                  :error-messages="errors.collect('riAppTxt')"
                                  v-validate="'max:8000|entry'"
                                  data-vv-validate-on="change"
                                  data-vv-name="riAppTxt"
                                  :data-vv-as="labels.riAppTxt"
                                  :counter="8000"
                                  :rows="15"
                                  readonly
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item :key="2">
                        <v-card>
                          <v-card-text>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-textarea
                                  v-model="riForm.riAppEndtTxt"
                                  :error-messages="errors.collect('riAppEndtTxt')"
                                  v-validate="'max:8000|entry'"
                                  data-vv-validate-on="change"
                                  data-vv-name="riAppEndtTxt"
                                  :data-vv-as="labels.riAppEndtTxt"
                                  :counter="8000"
                                  :rows="15"
                                  readonly
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-spacer class="mt-1"></v-spacer>
        <v-card v-if="!disableRiOutRiskPrem">
          <v-toolbar dense color="grey lighten-5" flat>
            <div class="v-icon mdi mdi-format-list-bulleted theme--light d-flex">
              <span class="headerTitle-b">{{riHeaderDisplay}} RI Details</span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="showRiDetails = !showRiDetails">
              <v-icon primary v-if="showRiDetails">mdi-chevron-down</v-icon>
              <v-icon primary v-else>mdi-chevron-up</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="showRiDetails">
            <div style="padding-left: 15px">
              <v-layout row wrap>
                <v-flex xs6 md6 lg4>
                  <v-autocomplete
                    v-model="riDetailInfo.cesEndtCnt"
                    :items="cessEndtList"
                    :label="labels.cesEndtCnt"
                    item-text="text"
                    item-value="value"
                    data-vv-name="cesEndtCnt"
                    :error-messages="errors.collect('cesEndtCnt')"
                    :data-vv-as="labels.cesEndtCnt"
                    @change="getRiDetailLists()"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 md6 lg4
                  ><span class="caption grey--text font-weight-light">(Note: Change CessEndt count to view previous records).</span></v-flex
                >
              </v-layout>
            </div>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-data-table
                    :headers="listRIDetails"
                    :items="riDetailItems"
                    :server-items-length="totalItemsRiDetail"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    :options.sync="paginationRiDetail"
                    item-key="key"
                    :loading="loading"
                    :no-data-text="noDataText"
                    :calculate-widths=true
                  >
                    <template v-slot:item="row">
                      <tr>
                        <td v-for="column in selectedRIDetailColumns" :key="column">
                          {{ column === 'riskNo' ? row.item['riskGrpNo'].toString().padStart(2, '0') + '/' + row.item[column].toString().padStart(3, '0') : row.item[column]  }}
                        </td>
                        <td class="table-action-header">
                          <table-action :rowData="row" query @query="doReviewDetails(row.item)"></table-action>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <v-simple-table>
                        <tbody>
                          <tr>
                            <td style="width: 95px"></td>
                            <td style="width: 95px"></td>
                            <td class="text-right"  style="width: 95px">
                              <strong>Total:</strong>
                            </td>
                            <td style="width: 95px">{{ getRIPremiumTotal }}</td>
                            <td style="width: 95px">{{ getRIComm1Total }}</td>
                            <td style="width: 95px">{{ getRIComm2Total }}</td>
                            <td style="width: 95px">{{ getRIComm3Total }}</td>
                            <td style="width: 95px">{{ getRINetPremTotal }}</td>
                            <td style="width: 95px">{{ getRILevyTotal }}</td>
                            <td style="width: 95px">{{ getRITaxTotal }}</td>
                            <td style="width: 89px"></td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
        <v-spacer class="mt-1"></v-spacer>
        <v-card id="riDetailFormCard" v-if="!disableRiOutRiskPrem">
          <v-toolbar dense color="grey lighten-5" flat>
            <div class="v-icon mdi mdi-format-align-justify theme--light d-flex">
              <span class="headerTitle-b"
                >{{riHeaderDisplay}} RI Details for
                <span class="caption grey--text font-weight-light">({{ riDetailLabels.riskDesc }}: {{ riDetailForm.riskDesc }})</span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="showRiDetailForm = !showRiDetailForm">
              <v-icon primary v-if="showRiDetailForm">mdi-chevron-down</v-icon>
              <v-icon primary v-else>mdi-chevron-up</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="showRiDetailForm">
            <v-layout row wrap>
              <v-flex xs6 md6 lg6>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riSIPctAE" disabled></v-checkbox>
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      v-model="riDetailForm.riSIPct"
                      :label="riDetailLabels.riSIPct"
                      :data-vv-as="riDetailLabels.riSIPct"
                      v-validate="'entry'"
                      data-vv-name="riSIPct"
                      :error-messages="errors.collect('riSIPct')"
                      disabled
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riSIAE" disabled />
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      ref="riSId"
                      v-model="riDetailForm.riSI"
                      :label="riDetailLabels.riSI"
                      :data-vv-as="riDetailLabels.riSI"
                      v-validate="'entry'"
                      data-vv-name="riSI"
                      :error-messages="errors.collect('riSI')"
                      disabled
                      v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riPremAE" disabled />
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      ref="riPremd"
                      v-model="riDetailForm.riPrem"
                      :label="riDetailLabels.riPrem"
                      :data-vv-as="riDetailLabels.riPrem"
                      v-validate="'entry'"
                      data-vv-name="riPrem"
                      :error-messages="errors.collect('riPrem')"
                      disabled
                      v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6>
                <v-layout>
                  <v-flex xs1 md1 lg1></v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      v-model="riDetailForm.prtyLim"
                      :label="riDetailLabels.prtyLim"
                      :data-vv-as="riDetailLabels.prtyLim"
                      v-validate="'entry'"
                      data-vv-name="prtyLim"
                      :error-messages="errors.collect('prtyLim')"
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6 order-lg1 order-md1>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riComm1AE" disabled />
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      ref="riComm1d"
                      v-model="riDetailForm.riComm1"
                      :label="riDetailLabels.riComm1"
                      :data-vv-as="riDetailLabels.riComm1"
                      v-validate="'entry'"
                      data-vv-name="riComm1"
                      :error-messages="errors.collect('riComm1')"
                      disabled
                      v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6 order-lg3 order-md3>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riComm2AE" disabled />
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      ref="riComm2d"
                      v-model="riDetailForm.riComm2"
                      :label="riDetailLabels.riComm2"
                      :data-vv-as="riDetailLabels.riComm2"
                      v-validate="'entry'"
                      data-vv-name="riComm2"
                      :error-messages="errors.collect('riComm2')"
                      disabled
                      v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6 order-lg5 order-md5>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riComm3AE" disabled />
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      ref="riComm3d"
                      v-model="riDetailForm.riComm3"
                      :label="riDetailLabels.riComm3"
                      :data-vv-as="riDetailLabels.riComm3"
                      v-validate="'entry'"
                      data-vv-name="riComm3"
                      :error-messages="errors.collect('riComm3')"
                      disabled
                      v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6 order-lg2 order-md2>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riLevyAE" disabled></v-checkbox>
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      v-model="riDetailForm.riLevy"
                      :label="riDetailLabels.riLevy"
                      :data-vv-as="riDetailLabels.riLevy"
                      v-validate="'entry'"
                      data-vv-name="riLevy"
                      :error-messages="errors.collect('riLevy')"
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 md6 lg6 order-lg4 order-md4>
                <v-layout>
                  <v-flex xs1 md1 lg1>
                    <v-checkbox left color="primary" v-model="riDetailForm.riTaxAE" disabled></v-checkbox>
                  </v-flex>
                  <v-flex xs10 md10 lg10>
                    <v-text-field
                      v-model="riDetailForm.riTax"
                      :label="riDetailLabels.riTax"
                      :data-vv-as="riDetailLabels.riTax"
                      v-validate="'entry'"
                      data-vv-name="riTax"
                      :error-messages="errors.collect('riTax')"
                      disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-spacer class="mt-1"></v-spacer>
        <v-card v-if="showRiOutBord">
          <v-toolbar dense color="grey lighten-5" text>
            <div class="v-icon mdi mdi-format-align-justify theme--light d-flex">
              <span class="headerTitle-b">{{riHeaderDisplay}} Bordereaux Item Details</span>
              <v-spacer></v-spacer>
              <!-- <v-btn class="mx-2" fab dark small color="primary"
                @click.prevent="doAddRiOutBord" :loading="loading">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn> -->
            </div>
          </v-toolbar>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-flex xs12 class="mt-3" v-if="messages.length > 0">
                <message :messages="messages"></message>
              </v-flex>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-data-table
                    v-bind:headers="listRIOutBord"
                    v-bind:items="riOutBordItems"
                    :server-items-length="totalItemsRiOutBord"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    v-bind:options.sync="paginationRiOutBord"
                    item-key="itemNo"
                    :loading="loading"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row">
                      <tr
                        :class="{ activeRowRiOutBord: selectedRiOutBordRecord == parseInt(row.item.itemNo) }"
                        @dblclick="doQueryRiOutBord(row.item)"
                      >
                        <td v-for="column in selectedRIOutBordColumns" :key="column">
                          {{ row.item[column] }}
                        </td>
                        <td class="table-action-header">
                          <table-action
                            :rowData="row"
                            query
                            @query="doQueryRiOutBord(row.item)"
                          ></table-action>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-spacer class="mt-1"></v-spacer>
        <v-card id="riFormCard" v-if="showRiOutBord && disableRiOutRiskPrem">
          <v-toolbar dense color="grey lighten-5" flat>
            <div class="v-icon mdi mdi-leaf theme--light d-flex">
              <span class="headerTitle-b"
                >{{riHeaderDisplay}} RI Bordereaux
                <span class="caption grey--text font-weight-light">(Query)</span>
              </span>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="showRiOutBordDetails = !showRiOutBordDetails">
              <v-icon primary v-if="showRiOutBordDetails">mdi-chevron-down</v-icon>
              <v-icon primary v-else>mdi-chevron-up</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="showRiOutBordDetails">
            <v-layout row wrap>
              <!-- <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                <v-text-field
                  v-model="riForm.riTypeCo"
                  :label="labels.riTypeCo"
                  :data-vv-as="labels.riTypeCo"
                  v-validate="'entry'"
                  data-vv-name="riTypeCo"
                  :error-messages="errors.collect('riTypeCo')"
                  :disabled="true"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs6 md6 lg4>
                <v-subheader class="queryLabel">{{ labels.riTypeCo }}</v-subheader>
                <div class="queryValue">{{ riForm.riTypeCo }}</div>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <cal-picker
                  v-model="riForm.riComDate"
                  :label="labels.riComDate"
                  :data-vv-as="labels.riComDate"
                  data-vv-name="riComDate"
                  :error-messages="errors.collect('riComDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <v-flex xs6 md6 lg4>
                <cal-picker
                  v-model="riForm.riExpDate"
                  :label="labels.riExpDate"
                  :data-vv-as="labels.riExpDate"
                  data-vv-name="riExpDate"
                  :error-messages="errors.collect('riExpDate')"
                  :disabled="true"
                ></cal-picker>
              </v-flex>
              <!-- <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                <v-autocomplete
                  :items="bordItemList"
                  v-model="riForm.itemNo"
                  :label="labels.itemNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="itemNo"
                  :data-vv-as="labels.itemNo"
                  :error-messages="errors.collect('itemNo')"
                  clearable
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex> -->
              <v-flex xs6 md6 lg4>
                <v-subheader class="queryLabel">{{ labels.itemNo }}</v-subheader>
                <div class="queryValue">{{ riForm.itemNo }}</div>
              </v-flex>
              <!-- <v-flex xs6 md6 lg4 v-if="newRiOutBord">
                <v-text-field
                  v-model="riForm.cedPolNo"
                  :label="labels.cedPolNo"
                  :data-vv-as="labels.cedPolNo"
                  v-validate="'entry'"
                  data-vv-name="cedPolNo"
                  :error-messages="errors.collect('cedPolNo')"
                  :disabled="true"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs6 md6 lg4>
                <v-subheader class="queryLabel">{{ labels.cedPolNo }}</v-subheader>
                <div class="queryValue">{{ riForm.cedPolNo }}</div>
              </v-flex>
              <v-flex xs6 md6 lg4></v-flex>
              <v-flex xs1 md1 lg1>
                <v-checkbox
                  class="align-end justify-end"
                  primary
                  hide-details
                  v-model="riForm.riSIAE"
                  :disabled="queryRiOutBord"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riSI"
                  :label="labels.riSI"
                  :data-vv-as="labels.riSI"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  data-vv-name="riSI"
                  :error-messages="errors.collect('riSI')"
                  @blur="recalculateRIOutBord"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs5 md5 lg3>
                <v-subheader class="queryLabel">{{ labels.riSI }}</v-subheader>
                <div class="queryValue">{{ riForm.riSI }}</div>
              </v-flex>
              <!-- <v-flex xs6 md6 lg4 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riSIPct"
                  :label="labels.riSIPct"
                  :data-vv-as="labels.riSIPct"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                  data-vv-name="riSIPct"
                  :error-messages="errors.collect('riSIPct')"
                  @blur="recalculateRIOutBord"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs6 md6 lg4>
                <v-subheader class="queryLabel">{{ labels.riSIPct }}</v-subheader>
                <div class="queryValue">{{ riForm.riSIPct }}</div>
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-checkbox
                  class="align-end justify-end"
                  primary
                  hide-details
                  v-model="riForm.riPremAE"
                  :disabled="queryRiOutBord"
                  @change="recalculateRIOutBord"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riPrem"
                  :label="labels.riPrem"
                  :data-vv-as="labels.riPrem"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  data-vv-name="riPrem"
                  :error-messages="errors.collect('riPrem')"
                  :disabled="disableRiPrem"
                  @blur="recalculateRIOutBord"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs5 md5 lg3>
                <v-subheader class="queryLabel">{{ labels.riPrem }}</v-subheader>
                <div class="queryValue">{{ riForm.riPrem }}</div>
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-checkbox
                  class="align-end justify-end"
                  primary
                  hide-details
                  v-model="riForm.riComm1AE"
                  :disabled="queryRiOutBord"
                  @change="recalculateRIOutBord"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riComm1"
                  :label="labels.riComm1"
                  :data-vv-as="labels.riComm1"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  data-vv-name="riComm1"
                  :error-messages="errors.collect('riComm1')"
                  :disabled="disableRiComm1"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs5 md5 lg3>
                <v-subheader class="queryLabel">{{ labels.riComm1 }}</v-subheader>
                <div class="queryValue">{{ riForm.riComm1 }}</div>
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-checkbox
                  class="align-end justify-end"
                  primary
                  hide-details
                  v-model="riForm.riComm2AE"
                  :disabled="queryRiOutBord"
                  @change="recalculateRIOutBord"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riComm2"
                  :label="labels.riComm2"
                  :data-vv-as="labels.riComm2"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  data-vv-name="riComm2"
                  :error-messages="errors.collect('riComm2')"
                  :disabled="disableRiComm2"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs5 md5 lg3>
                <v-subheader class="queryLabel">{{ labels.riComm2 }}</v-subheader>
                <div class="queryValue">{{ riForm.riComm2 }}</div>
              </v-flex>
              <v-flex xs1 md1 lg1>
                <v-checkbox
                  class="align-end justify-end"
                  primary
                  hide-details
                  v-model="riForm.riComm3AE"
                  :disabled="queryRiOutBord"
                  @change="recalculateRIOutBord"
                ></v-checkbox>
              </v-flex>
              <!-- <v-flex xs5 md5 lg3 v-if="!queryRiOutBord">
                <v-text-field
                  v-model="riForm.riComm3"
                  :label="labels.riComm3"
                  :data-vv-as="labels.riComm3"
                  v-validate="'entry'"
                  v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                  data-vv-name="riComm3"
                  :error-messages="errors.collect('riComm3')"
                  :disabled="disableRiComm3"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs5 md5 lg3>
                <v-subheader class="queryLabel">{{ labels.riComm3 }}</v-subheader>
                <div class="queryValue">{{ riForm.riComm3 }}</div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="riCoDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Company</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riCoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doInterFilters"
                                v-model="filters.inter"
                                :label="filtersLabel.inter"
                                :error-messages="errors.collect('inter')"
                                data-vv-name="inter"
                                :data-vv-as="filtersLabel.inter"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doInterFilters"
                                v-model="filters.name"
                                :label="filtersLabel.name"
                                :error-messages="errors.collect('name')"
                                data-vv-name="name"
                                :data-vv-as="filtersLabel.name"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearInterFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doInterFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRICo"
              v-bind:items="riCoItems"
              :server-items-length="totalItemsRiCo"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiCo"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.inter }}</td>
                  <td>{{ row.item.name }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiCo(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riTreatyDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Treaty</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riTreatyDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doTreatyFilters"
                                v-model="filters.ttyNo"
                                :label="filtersLabel.ttyNo"
                                :error-messages="errors.collect('ttyNo')"
                                data-vv-name="ttyNo"
                                :data-vv-as="filtersLabel.ttyNo"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex lg6 xs12>
                              <v-text-field
                                v-on:keydown.enter.prevent="doTreatyFilters"
                                v-model="filters.ttyDesc"
                                :label="filtersLabel.ttyDesc"
                                :error-messages="errors.collect('ttyDesc')"
                                data-vv-name="ttyDesc"
                                :data-vv-as="filtersLabel.ttyDesc"
                                v-validate="'entry|max:100'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions right>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearTreatyFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text @click.prevent="doTreatyFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRITreaty"
              v-bind:items="riTreatyItems"
              :server-items-length="totalItemsRiTreaty"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiTreaty"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.ttyNo }}</td>
                  <td>{{ row.item.ttyDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiTreaty(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riAcctNoSfxDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Treaty</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riAcctNoSfxDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRIAcctNoSfx"
              v-bind:items="riAcctNoSfxItems"
              :server-items-length="totalItemsRiAcctNoSfx"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiTreaty"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.acctNoSfx }}</td>
                  <td>{{ row.item.acctNoSfxDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="doSelectRiAcctNoSfx(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="riAppTxtDialog" width="50%" persistent>
      <v-card>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.riAppTxt }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-tabs slider-color="teal">
                  <v-tab ripple :key="1">{{ labels.riAppTxt }}</v-tab>
                  <v-tab ripple :key="2">{{ labels.riAppEndtTxt }}</v-tab>
                  <v-tabs-items>
                    <v-tab-item :key="1">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="riForm.riAppTxtTemp"
                                :error-messages="errors.collect('riAppTxt')"
                                v-validate="'max:8000|entry'"
                                data-vv-validate-on="change"
                                data-vv-name="riAppTxt"
                                :data-vv-as="labels.riAppTxt"
                                :counter="8000"
                                :rows="20"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="2">
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-textarea
                                v-model="riForm.riAppEndtTxtTemp"
                                :error-messages="errors.collect('riAppEndtTxt')"
                                v-validate="'max:8000|entry'"
                                data-vv-validate-on="change"
                                data-vv-name="riAppEndtTxt"
                                :data-vv-as="labels.riAppEndtTxt"
                                :counter="8000"
                                :rows="20"
                              ></v-textarea>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-tabs>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click.native="riAppTxtDialog = false"><span class="btn-normal-error">Close</span></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { commonMixins } from '@/mixins/common/commonMixin'
import { riAjaxMixin } from '@/mixins/reinsurance/riAjaxMixin'
import { riListMixin } from '@/mixins/reinsurance/riListMixin'
import * as TableConst from '@/mixins/table'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { formatPrice } from '@/utils/index'
import clone from 'clone'
export default {
  data() {
    return {
      showRiDetails: false,
      showRiDetailForm: false,
      showRiDetailsDialog: false,
      showRiText: false,
      showRiOutBord: false,
      showRiOutBordDetails: true,
      queryRiOutBord: true,
      disableRiOutRiskPrem: false,
      filters: {
        ttyNo: '',
        ttyDesc: '',
        inter: '',
        name: ''
      },
      filtersLabel: {
        ttyNo: 'Treaty No.',
        ttyDesc: 'Treaty Name',
        inter: 'Intermediary No.',
        name: 'Intermediary Name'
      },
      labels: {
        riType: 'RI Type',
        cesEndtCnt: 'CessEndt Count',
        riCo: 'RI Company / Treaty',
        propXl: 'Proportional / XOL',
        acctNoSfx: 'Account No. Suffix',
        theirPolNo: 'Their Policy No.',
        cesNo: 'Cession No.',
        cesYr: 'Cession Year',
        bordEreAux: 'Bordereaux',
        prtRiApp: 'Print RI Closing',
        relRi: 'Release Now',
        tranDate: 'Transaction Date',
        riComDate: 'Commencement Date',
        riExpDate: 'Expiry Date',
        comm1Pct: 'Commission 1 %',
        comm2Pct: 'Commission 2 %',
        comm2Gn: 'Gross/Net',
        comm3Pct: 'Commission 3 %',
        comm3Gn: 'Gross/Net',
        stampDuty: 'Stamp Duty',
        riTax: 'Tax',
        riLevy: 'RI Levy',
        ccaDate: 'Acceptance Date',
        ccdDate: 'Documentation date',
        ccDateEntUsr: 'Entered By',
        ccDateRevUsr: 'Reviewed By',
        riAppTxt: 'RI Application Text',
        riAppEndtTxt: 'RI Application Endt Text',
        promptRemove: 'Are you sure you want to delete the selected RI Header?',
        cesEndtNo: 'Cession Endorsement No.',
        cesStamp: 'Cession Stamp',
        riEndtDate: 'Endorsement Date',
        relDate: 'Release Date',
        relUsr: 'Release By',
        billCurr: 'Billing Currency',
        docNo: 'Document No.',
        itemNo: 'Bordereaux Item',
        cedPolNo: 'Reference No.',
        riSI: 'Sum Insured',
        riSIPct: 'Sum Insured %',
        riPrem: 'RI Premium',
        riComm1: 'RI Comm 1',
        riComm2: 'RI Comm 2',
        riComm3: 'RI Comm 3',
        riTypeCo: 'RI Type - RI Company'
      },
      totalItemsRI: 0,
      paginationRI: {
        sortBy: [],
        descending: false,
        page: 1,
        rowsPerPage: 5
      },
      riTreatyDialog: false,
      riCoDialog: false,
      riAcctNoSfxDialog: false,
      selectedRi: {},
      showRiForm: false,
      riAppTxtDialog: false,
      riForm: {
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        billCurr: undefined,
        billCurrRate: undefined,
        dept: undefined,
        cesEndtCnt: 0,
        riType: undefined,
        riCo: undefined,
        propXl: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        theirPolNo: undefined,
        cesNo: undefined,
        cesYr: undefined,
        bordEreAux: false,
        prtRiApp: false,
        relRi: false,
        tranDate: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        comm1AE: undefined,
        comm1Pct: 0,
        comm2AE: false,
        comm2Pct: 0,
        comm2Gn: 'G',
        comm3AE: false,
        comm3Pct: 0,
        comm3Gn: 'G',
        stampDuty: 0,
        riTax: 0,
        riLevy: 0,
        actionName: 0,
        ccaDate: undefined,
        ccdDate: undefined,
        ccDateEntUsr: undefined,
        ccDateRevUsr: undefined,
        cesEndtNo: undefined,
        cesStamp: 0,
        riEndtDate: undefined,
        relDate: undefined,
        relUsr: undefined,
        docNo: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        cedPolNo: undefined,
        riSIAE: false,
        riSI: 0,
        riSIPct: 0,
        riPremAE: true,
        riPrem: 0,
        riComm1AE: true,
        riComm1: 0,
        riComm2AE: true,
        riComm2: 0,
        riComm3AE: true,
        riComm3: 0,
        riTypeCo: undefined,
        addRI: false,
        acctMth: undefined,
        acctYr: undefined,
        selectedComm: '',
        tranDateValidationMessage: undefined,
        tranDateValidation: false,
        acctNoSfxWithDesc: undefined
      },
      cessEndtCtr: 0,
      promptRemove: false,
      selectedRIHeader: undefined,
      deleteRIHeader: undefined,
      riHeaderColumns: [
        { text: 'RI Type', value: 'riType' },
        { text: 'RI Company', value: 'riCoDesc' },
        { text: 'Account Suffix', value: 'acctNoSfxWithDesc' },
        { text: 'CessEndt Count', value: 'cesEndtCnt' },
        { text: 'P/X', value: 'propXlDesc' },
        { text: 'Comm Date', value: 'comDateDisp' },
        { text: 'Expiry Date', value: 'expDateDisp' },
        TableConst.tableActionHeader
      ],
      riDetailLabels: {
        riskDesc: 'Risk Group / No',
        riSI: 'RI Sum Insured (Amount)',
        riSIPct: 'RI Sum Insured %',
        riPrem: 'RI Premium',
        prtyLim: 'Priority Limit',
        riComm1: 'RI Commission 1',
        riComm2: 'RI Commission 2',
        riComm3: 'RI Commission 3',
        riLevy: 'RI Levy',
        riTax: 'RI Tax'
      },
      riDetailForm: {
        polNo: undefined,
        renCnt: undefined,
        cesEndtCnt: undefined,
        riType: undefined,
        riCo: undefined,
        acctNoSfx: undefined,
        riskGrpNo: undefined,
        riskNo: undefined,
        endtCnt: undefined,
        riskDesc: undefined,
        riSI: undefined,
        riSIAE: true,
        riSIPct: undefined,
        riSIPctAE: true,
        riPrem: undefined,
        riPremAE: true,
        prtyLim: undefined,
        riComm1: undefined,
        riComm1AE: true,
        riComm2: undefined,
        riComm2AE: true,
        riComm3: undefined,
        riComm3AE: true,
        riLevy: undefined,
        riLevyAE: true,
        riTax: undefined,
        riTaxAE: true,
        actionName: 0
      },
      riDetailInfo: {
        riType: undefined,
        riTypeDesc: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        cesEndtCnt: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        propXl: undefined,
        propXlDesc: undefined,
        riComDate: undefined,
        riExpDate: undefined,
        riComm2Gn: undefined,
        riComm3Gn: undefined
      },
      selectedRecord: '',
      selectedRiOutBordRecord: '',
      selectedRow: {},
      riAppTxtTabMenu: undefined,
      txtTab: [],
      riHeaderDisplay: ''
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('riOutInit')])
      await this.$store.dispatch('riOutListingInit')
      this.getRiOutMasterList()
    },
    resetActiveRow() {
      const rows = Array.from(document.querySelectorAll('tr.activeRow'))
      rows.forEach(row => {
        row.classList.remove('activeRow')
      })
      this.selectedRecord = {}
    },
    resetRiOutBord() {
      this.riForm.itemNo = undefined
      this.riForm.cedPolNo = undefined
      this.riForm.riSIAE = false
      this.riForm.riSI = 0
      this.riForm.riSIPct = 0
      this.riForm.riPremAE = true
      this.riForm.riPrem = 0
      this.riForm.riComm1AE = true
      this.riForm.riComm1 = 0
      this.riForm.riComm2AE = true
      this.riForm.riComm2 = 0
      this.riForm.riComm3AE = true
      this.riForm.riComm3 = 0
      this.riForm.riTypeCo = undefined
    },
    resetActiveRowRiOutBord() {
      const rows = Array.from(document.querySelectorAll('tr.activeRowRiOutBord'))
      rows.forEach((row) => {
        row.classList.remove('activeRowRiOutBord')
      })
      this.selectedRiOutBordRecord = {}
    },
    doShowRiDetails() {
      if (!this.showRiOutBord) {
        this.showRiDetails = true
      } else {
        this.showRiDetails = false
      }
      if (this.selectedRow !== null) {
        this.cessEndtCtr = this.selectedRow.cesEndtCnt
        this.selectedRi = this.selectedRow
        this.riDetailInfo.riType = this.selectedRi.riType
        this.riTypeList.map(riType => {
          if (riType.value === this.selectedRi.riType) {
            this.riDetailInfo.riTypeDesc = riType.label
          }
        })
        this.riDetailInfo.riCo = this.selectedRi.riCo
        this.riDetailInfo.riCoDesc = this.selectedRi.riCoDesc
        this.riDetailInfo.acctNoSfx = this.selectedRi.acctNoSfx
        this.riDetailInfo.acctNoSfxDesc = this.selectedRi.acctNoSfxDesc
        this.riDetailInfo.propXl = this.selectedRi.propXl
        this.riDetailInfo.propXlDesc = this.selectedRi.propXlDesc
        this.riDetailInfo.riComDate = this.selectedRi.comDateDisp
        this.riDetailInfo.riExpDate = this.selectedRi.expDateDisp
        this.riDetailInfo.riComm2Gn = this.selectedRi.riComm2Gn
        this.riDetailInfo.riComm3Gn = this.selectedRi.riComm3Gn
        this.riDetailInfo.cesEndtCnt = this.selectedRi.cesEndtCnt
        this.doReview(this.selectedRow).then(() => {
          if (this.riDetailItems.length > 0) {
            this.doDetailEdit(this.riDetailItems[0])
          }
        })
      }
    },
    activateRow(row) {
      this.selectedRecord = row.riType + '-' + row.riCoDesc + '-' + row.acctNoSfxWithDesc
      this.selectedRow = row
    },
    activeRowRiOutBord(props) {
      this.selectedRiOutBordRecord = parseInt(props.itemNo)
    },
    openRiAppTxt() {
      this.riForm.riAppTxtTemp = this.riForm.riAppTxt
      this.riForm.riAppEndtTxtTemp = this.riForm.riAppEndtTxt
      this.riAppTxtDialog = true
    },
    async getRiOutMasterList() {
      this.selectedRi.polNo = this.polMaster.polNo
      this.selectedRi.renCnt = this.polMaster.renCnt
      this.selectedRi.endtCnt = this.polMaster.endtCnt
      this.key = 'key'
      this.doFetchRIHeaders(false).then(() => {
        if (this.riHeaderItems.length > 0) {
          // this.doEdit(this.riHeaderItems[0])
        }
      })
    },
    getRIType(key) {
      for (let riType of this.riTypeList) {
        if (riType.value === key) {
          return riType
        }
      }
      return ''
    },
    async doEdit(data) {
      this.riHeaderDisplay = data.riType + ' / ' + data.riCo + ' / ' + data.acctNoSfx + ' -'
      this.activateRow(data)
      this.showRiForm = false
      this.showRiDetailForm = false
      this.cessEndtCtr = data.cesEndtCnt
      await this.doFetchRiHeader(data).then(() => {
        this.doShowRiDetails()
      })
    },
    async getDetails() {
      this.resetMessages()
      let riData = {
        polNo: this.riForm.polNo,
        renCnt: this.riForm.renCnt,
        cesEndtCnt: this.riForm.cesEndtCnt,
        riType: this.riForm.riType,
        riCo: this.riForm.riCo,
        acctNoSfx: this.riForm.acctNoSfx,
        endtCnt: this.riForm.endtCnt
      }
      this.doFetchRiHeader(riData)
    },
    async doFetchRiHeader(riData) {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiHeaderDetail
      const requestParams = {
        polNo: riData.polNo,
        renCnt: riData.renCnt,
        cesEndtCnt: riData.cesEndtCnt,
        riType: riData.riType,
        riCo: riData.riCo,
        acctNoSfx: riData.acctNoSfx,
        endtCnt: riData.endtCnt
      }
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data && data.riHeaderDetail) {
            this.riForm.cesEndtCnt = data.riHeaderDetail.cesEndtCnt
            this.riForm.riType = data.riHeaderDetail.riType
            this.riForm.riCo = data.riHeaderDetail.riCo
            this.riForm.polNo = data.riHeaderDetail.polNo
            this.riForm.renCnt = data.riHeaderDetail.renCnt
            this.riForm.endtCnt = data.riHeaderDetail.endtCnt
            this.riForm.riCoDesc = data.riHeaderDetail.riCo + ' - ' + data.inter
            this.riForm.propXl = data.riHeaderDetail.propXl
            this.riForm.acctNoSfx = data.riHeaderDetail.acctNoSfx
            this.riForm.acctNoSfxDesc = data.acctNoSfxDesc
            if (this.riForm.acctNoSfx === '' || this.riForm.acctNoSfx === undefined) {
              this.riForm.acctNoSfxWithDesc = ''
            } else {
              this.riForm.acctNoSfxWithDesc = this.riForm.acctNoSfx + ' - ' + this.riForm.acctNoSfxDesc
            }
            this.riForm.theirPolNo = data.riHeaderDetail.theirPolNo
            this.riForm.cesNo = data.riHeaderDetail.cesNo
            this.riForm.cesYr = data.riHeaderDetail.cesYr
            this.riForm.bordEreAux = data.riHeaderDetail.bordEreAux
            this.riForm.prtRiApp = data.riHeaderDetail.prtRiApp
            this.riForm.relRi = data.riHeaderDetail.relRi
            this.riForm.tranDate = data.riHeaderDetail.tranDate
            this.riForm.riComDate = data.riHeaderDetail.riComDate
            this.riForm.riExpDate = data.riHeaderDetail.riExpDate
            this.riForm.comm1AE = data.riHeaderDetail.comm1AE
            this.riForm.comm1Pct = formatDisplayNumber(data.riHeaderDetail.comm1Pct, 6)
            this.riForm.comm2AE = data.riHeaderDetail.comm2AE
            this.riForm.comm2Pct = formatDisplayNumber(data.riHeaderDetail.comm2Pct, 6)
            this.riForm.comm2Gn = data.riHeaderDetail.comm2Gn
            this.riForm.comm3AE = data.riHeaderDetail.comm3AE
            this.riForm.comm3Pct = formatDisplayNumber(data.riHeaderDetail.comm3Pct, 6)
            this.riForm.comm3Gn = data.riHeaderDetail.comm3Gn
            this.riForm.stampDuty = formatDisplayNumber(data.riHeaderDetail.stampDuty, 3)
            this.riForm.riTax = formatDisplayNumber(data.riHeaderDetail.riTax, 3)
            this.riForm.riLevy = formatDisplayNumber(data.riHeaderDetail.riLevy, 3)
            this.riForm.riAppTxt = data.riHeaderDetail.riAppTxt
            this.riForm.riAppEndtTxt = data.riHeaderDetail.riAppEndtTxt
            this.riForm.ccaDate = data.riHeaderDetail.ccaDate
            this.riForm.ccdDate = data.riHeaderDetail.ccdDate
            this.riForm.ccDateEntUsr = data.riHeaderDetail.ccDateEntUsr
            this.riForm.ccDateRevUsr = data.riHeaderDetail.ccDateRevUsr
            // LYT 2020-12-22 OS-618
            this.riForm.cesEndtNo = data.riHeaderDetail.cesEndtNo
            this.riForm.cesStamp = formatPrice(data.riHeaderDetail.cesStamp)
            this.riForm.riEndtDate = data.riHeaderDetail.riEndtDate
            this.riForm.docNo =
              (data.riHeaderDetail.tranType1 !== undefined ? data.riHeaderDetail.tranType1 : '') +
              (data.riHeaderDetail.docNo !== undefined ? data.riHeaderDetail.docNo : '')
            this.riForm.billCurr = data.riHeaderDetail.billCurr
            // 2021-05-21 OS-792
            this.riForm.relDate = data.riHeaderDetail.relDate
            this.riForm.relUsr = data.riHeaderDetail.relUsr !== '0' ? data.riHeaderDetail.relUsr : ''
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async doQueryRiOutBord(data) {
      this.resetMessages()
      this.showRiOutBord = true
      this.activeRowRiOutBord(data)
      this.newRiOutBord = false
      this.editRiOutBord = false
      this.queryRiOutBord = true
      await this.doFetchRiOutBord(data)
    },
    bordEreAuxChanged() {
      if (this.riForm.bordEreAux) {
        this.riForm.ccaDate = undefined
        this.riForm.ccdDate = undefined
      }
    },
    doShowRiCo() {
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W') {
        this.riTreatyDialog = true
        this.doClearTreatyFilters()
      } else if (this.riForm.riType === 'C' || this.riForm.riType === 'D' || this.riForm.riType === 'F') {
        this.riCoDialog = true
        this.doClearInterFilters()
      }
    },
    doShowAcctNoSfx() {
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxDialog = true
        this.riAcctNoSfxInit(5)
      }
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    removeFormatNumber(value) {
      return removeFormatNumber(value)
    },
    async populateRiDetails(data) {
      this.doReview(data)
    },
    async getRiDetailLists() {
      this.resetMessages()
      this.showRiDetailForm = true
      this.doReview(this.selectedRi).then(() => {
        if (this.riDetailItems.length > 0) {
          this.doDetailEdit(this.riDetailItems[0])
        }
      })
    },
    doReviewDetails(data) {
      this.showRiDetailForm = true
      this.doDetailEdit(data)
      this.$nextTick(() => {
        this.$vuetify.goTo('#riDetailFormCard')
      })
    },
    async doDetailEdit(riDetail) {
      this.selectedRi.riskGrpNo = riDetail.riskGrpNo
      this.selectedRi.riskNo = riDetail.riskNo
      await this.doFetchRiDetail(riDetail).then((result1) => {
        if (result1) {
          this.doFetchRiOutBordList(this.riDetailForm).then((result) => {
            if (result === false) {
              this.resetRiOutBord()
            } else {
              if (this.riOutBordItems.length > 0) {
                this.showRiOutBord = true
                this.doQueryRiOutBord(this.riOutBordItems[0])
              } else {
                this.showRiOutBord = false
              }
            }
          })
        }
      })
    },
    async doFetchRiDetail(riDetail) {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiDetailDetail
      const requestParams = {
        polNo: riDetail.polNo,
        renCnt: riDetail.renCnt,
        cesEndtCnt: riDetail.cesEndtCnt,
        riType: riDetail.riType,
        riCo: riDetail.riCo,
        acctNoSfx: riDetail.acctNoSfx,
        riskGrpNo: riDetail.riskGrpNo,
        riskNo: riDetail.riskNo,
        endtCnt: riDetail.endtCnt
      }
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          this.riDetailForm.riComm1Pct = riDetail.riComm1Pct
          this.riDetailForm.riComm2Pct = riDetail.riComm2Pct
          this.riDetailForm.riComm3Pct = riDetail.riComm3Pct
          if (data && data.riDetailDetail) {
            this.riDetailForm.polNo = data.riDetailDetail.polNo
            this.riDetailForm.renCnt = data.riDetailDetail.renCnt
            this.riDetailForm.cesEndtCnt = data.riDetailDetail.cesEndtCnt
            this.riDetailForm.riType = data.riDetailDetail.riType
            this.riDetailForm.riCo = data.riDetailDetail.riCo
            this.riDetailForm.acctNoSfx = data.riDetailDetail.acctNoSfx
            this.riDetailForm.riskGrpNo = data.riDetailDetail.riskGrpNo
            this.riDetailForm.riskNo = data.riDetailDetail.riskNo
            this.riDetailForm.endtCnt = data.riDetailDetail.endtCnt
            this.riDetailForm.riskDesc = data.riDetailDetail.riskGrpNo + ' / ' + data.riDetailDetail.riskNo
            this.riDetailForm.riSI = formatDisplayNumber(data.riDetailDetail.riSI, 2)
            this.riDetailForm.riSIAE = data.riDetailDetail.riSIAE
            this.riDetailForm.riSIPct = formatDisplayNumber(data.riDetailDetail.riSIPct, 6)
            this.riDetailForm.riSIPctDisp = formatDisplayNumber(data.riDetailDetail.riSIPct, 6)
            this.riDetailForm.riSIPctAE = data.riDetailDetail.riSIPctAE
            this.riDetailForm.riPrem = formatDisplayNumber(data.riDetailDetail.riPrem, 2)
            this.riDetailForm.riPremDisp = formatDisplayNumber(data.riDetailDetail.riPrem, 3)
            this.riDetailForm.riPremAE = data.riDetailDetail.riPremAE
            this.riDetailForm.prtyLim = data.riDetailDetail.prtyLim
            this.riDetailForm.riComm1AE = data.riDetailDetail.riComm1AE
            this.riDetailForm.riComm1 = formatDisplayNumber(data.riDetailDetail.riComm1, 2)
            this.riDetailForm.riComm1Disp = formatDisplayNumber(data.riDetailDetail.riComm1, 2)
            this.riDetailForm.riComm2AE = data.riDetailDetail.riComm2AE
            this.riDetailForm.riComm2 = formatDisplayNumber(data.riDetailDetail.riComm2, 2)
            this.riDetailForm.riComm2Disp = formatDisplayNumber(data.riDetailDetail.riComm2, 2)
            this.riDetailForm.riComm3AE = data.riDetailDetail.riComm3AE
            this.riDetailForm.riComm3 = formatDisplayNumber(data.riDetailDetail.riComm3, 2)
            this.riDetailForm.riComm3Disp = formatDisplayNumber(data.riDetailDetail.riComm3, 2)
            this.riDetailForm.riTax = formatDisplayNumber(data.riDetailDetail.riTax, 3)
            this.riDetailForm.riTaxDisp = formatDisplayNumber(data.riDetailDetail.riTax, 3)
            this.riDetailForm.riTaxAE = data.riDetailDetail.riTaxAE
            this.riDetailForm.riLevy = formatDisplayNumber(data.riDetailDetail.riLevy, 3)
            this.riDetailForm.riLevyDisp = formatDisplayNumber(data.riDetailDetail.riLevy, 3)
            this.riDetailForm.riLevyAE = data.riDetailDetail.riLevyAE
          }
          if (data && data.polRisk) {
            this.polRisk.premDue = data.polRisk.premDue
            this.polRisk.si = data.polRisk.si
          }
          if (data && data.riOutMaster) {
            this.riOutMaster.comm1Pct = data.riOutMaster.comm1Pct
            this.riOutMaster.comm2Pct = data.riOutMaster.comm2Pct
            this.riOutMaster.comm3Pct = data.riOutMaster.comm3Pct
          }
          this.loading = false
          return true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            return false
          }
        }
      }
      this.loading = false
    },
    async doReview(riData) {
      this.key = 1
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiDetailLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiDetail
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            polNo: this.selectedRi.polNo
          }
          // SR5662: RI Details Display for previous cesEndtCnt
          let riDataObj = clone(riData)
          riDataObj.cesEndtCnt = this.riDetailInfo.cesEndtCnt
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), riDataObj, this.paginationRiDetail.sortBy, this.paginationRiDetail.sortDesc)
          )
          if (result.data) {
            this.totalItemsRiDetail = result.data.totalElements
            const { data } = result.data
            this.riDetailItems = []
            if (data) {
              data.map(riDetail => {
                const convertRiOutHeader = {
                  polNo: this.selectedRi.polNo,
                  renCnt: riDetail.renCnt,
                  cesEndtCnt: riDetail.cesEndtCnt,
                  riType: riDetail.riType,
                  riCo: riDetail.riCo,
                  acctNoSfx: riDetail.acctNoSfx,
                  riskGrpNo: riDetail.riskGrpNo,
                  riskNo: riDetail.riskNo,
                  endtCnt: riDetail.endtCnt,
                  riSIAE: riDetail.riSIAE,
                  riSI: formatDisplayNumber(riDetail.riSI, 2),
                  riSIPctAE: riDetail.riSIPctAE,
                  riSIPct: riDetail.riSIPct,
                  riSIPctDisp: formatDisplayNumber(riDetail.riSIPct, 6),
                  riPremAE: riDetail.riPremAE,
                  riPrem: riDetail.riPrem,
                  riNetPrem: this.calculateRiNetPrem(riDetail.riPrem, riDetail.riComm1, riDetail.riComm2, riDetail.riComm3),
                  riNetPremDisp: formatDisplayNumber(
                    this.calculateRiNetPrem(riDetail.riPrem, riDetail.riComm1, riDetail.riComm2, riDetail.riComm3).toFixed(2),
                    2
                  ),
                  riPremDisp: formatDisplayNumber(riDetail.riPrem),
                  riComm1AE: riDetail.riComm1AE,
                  riComm1: riDetail.riComm1,
                  riComm1Disp: formatDisplayNumber(riDetail.riComm1, 2),
                  riComm2AE: riDetail.riComm2AE,
                  riComm2: riDetail.riComm2,
                  riComm2Disp: formatDisplayNumber(riDetail.riComm2, 2),
                  riComm3AE: riDetail.riComm3AE,
                  riComm3: riDetail.riComm3,
                  riComm3Disp: formatDisplayNumber(riDetail.riComm3, 2),
                  prtyLim: riDetail.prtyLim,
                  riLevyAE: riDetail.riLevyAE,
                  riLevy: riDetail.riLevy,
                  riLevyDisp: formatDisplayNumber(riDetail.riLevy, 4),
                  riTaxAE: riDetail.riTaxAE,
                  riTax: riDetail.riTax,
                  riTaxDisp: formatDisplayNumber(riDetail.riTax, 4),
                  riPremAccum: riDetail.riPremAccum,
                  riComm1Accum: riDetail.riComm1Accum,
                  riComm2Accum: riDetail.riComm2Accum,
                  riComm3Accum: riDetail.riComm3Accum,
                  riNetPremAccum: riDetail.riNetPremAccum,
                  riLevyAccum: riDetail.riLevyAccum,
                  riTaxAccum: riDetail.riTaxAccum
                }
                this.riDetailItems.push(convertRiOutHeader)
              })
            } else {
              this.riDetailItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    calculateRiNetPrem(riPrem, riComm1, riComm2, riComm3) {
      return Number(riPrem) + Number(riComm1) + Number(riComm2) + Number(riComm3)
    },
    formatMoney(val) {
      return formatPrice(val)
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    comDateValidation() {
      const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
      return result
    },
    expDateValidation() {
      const result = 'required|riHeader_comDate:' + this.selectedRi.comDate + '|riHeader_expDate:' + this.selectedRi.expDate
      return result
    },
    cessEndtList() {
      const cessEndtCnts = this.cessEndtCtr + 1
      return Array.from({ length: cessEndtCnts - 0 }, (value, index) => 0 + index)
    },
    // getRIPremiumTotal() {
    //   let riPremiumTot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riPremiumTot = riPremiumTot + riObj.riPrem
    //   })
    //   return formatDisplayNumber(riPremiumTot.toFixed(2), 2)
    // },
    // getRIComm1Total() {
    //   let riComm1Tot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riComm1Tot = riComm1Tot + riObj.riComm1
    //   })
    //   return formatDisplayNumber(riComm1Tot.toFixed(2), 2)
    // },
    // getRIComm2Total() {
    //   let riComm2Tot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riComm2Tot = riComm2Tot + riObj.riComm2
    //   })
    //   return formatDisplayNumber(riComm2Tot.toFixed(2), 2)
    // },
    // getRIComm3Total() {
    //   let riComm3Tot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riComm3Tot = riComm3Tot + riObj.riComm3
    //   })
    //   return formatDisplayNumber(riComm3Tot.toFixed(2), 2)
    // },
    // getRINetPremTotal() {
    //   let riNetPremTot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riNetPremTot = riNetPremTot + riObj.riNetPrem
    //   })
    //   return formatDisplayNumber(riNetPremTot.toFixed(2), 2)
    // },
    // getRILevyTotal() {
    //   let riLevyTot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riLevyTot = riLevyTot + riObj.riLevy
    //   })
    //   return formatDisplayNumber(riLevyTot.toFixed(4), 4)
    // },
    // getRITaxTotal() {
    //   let riTaxTot = 0
    //   this.riDetailItems.forEach(function(riObj) {
    //     riTaxTot = riTaxTot + riObj.riTax
    //   })
    //   return formatDisplayNumber(riTaxTot.toFixed(4), 4)
    // }
    getRIPremiumTotal() {
      // let riPremiumTot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riPremiumTot = riPremiumTot + riObj.riPrem
      // })
      // return formatDisplayNumber(riPremiumTot.toFixed(2), 2)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riPremAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm1Total() {
      // let riComm1Tot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riComm1Tot = riComm1Tot + riObj.riComm1
      // })
      // return formatDisplayNumber(riComm1Tot.toFixed(2), 2)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm1Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm2Total() {
      // let riComm2Tot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riComm2Tot = riComm2Tot + riObj.riComm2
      // })
      // return formatDisplayNumber(riComm2Tot.toFixed(2), 2)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm2Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRIComm3Total() {
      // let riComm3Tot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riComm3Tot = riComm3Tot + riObj.riComm3
      // })
      // return formatDisplayNumber(riComm3Tot.toFixed(2), 2)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riComm3Accum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRINetPremTotal() {
      // let riNetPremTot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riNetPremTot = riNetPremTot + riObj.riNetPrem
      // })
      // return formatDisplayNumber(riNetPremTot.toFixed(2), 2)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riNetPremAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRILevyTotal() {
      // let riLevyTot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riLevyTot = riLevyTot + riObj.riLevy
      // })
      // return formatDisplayNumber(riLevyTot.toFixed(4), 4)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riLevyAccum)
      } else {
        return formatDisplayNumber(0)
      }
    },
    getRITaxTotal() {
      // let riTaxTot = 0
      // this.riDetailItems.forEach(function(riObj) {
      //   riTaxTot = riTaxTot + riObj.riTax
      // })
      // return formatDisplayNumber(riTaxTot.toFixed(4), 4)
      if (this.riDetailItems.length > 0) {
        return formatDisplayNumber(this.riDetailItems[0].riTaxAccum)
      } else {
        return formatDisplayNumber(0)
      }
    }
    // cessEndtList() {
    //   const cessEndtCnts = this.cessEndtCtr + 1
    //   return Array.from({ length: cessEndtCnts - 0 }, (value, index) => 0 + index)
    // }
  },
  watch: {
    riOutBordItems: function (value) {
      if (this.riOutBordItems.length > 0) {
        this.disableRiOutRiskPrem = true
      } else {
        this.disableRiOutRiskPrem = false
      }
    },
    'paginationRiDetail': function (value) {
      this.doReview(this.selectedRow)
    }
  },
  created() {
    this.$validator.extend('riHeader_comDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be earlier than Policy's Commencement Date (10201)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var comDate = args[0]
          if (comDate) {
            return !isAfter(removeTime(comDate), removeTime(value))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('riHeader_expDate', {
      getMessage(field, args) {
        return `RI ${field} cannot be later than Policy's Expiry Date (20256)`
      },
      validate(value, args) {
        if (value) {
          if (args === void 0) args = []
          var expDate = args[0]
          if (expDate) {
            return !isAfter(removeTime(value), removeTime(expDate))
          } else return true
        } else return true
      }
    })
    this.$validator.extend('claims_Date_today', {
      getMessage(field, args) {
        return `The ${field} cannot be later than Today.`
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin, commonMixins, riAjaxMixin, riListMixin, TableConst.default]
}
</script>
<style lang="scss">
.activeRow {
  background-color: #fff9c4ff;
}
.activeRowRiOutBord {
  background-color: #fff9c4ff;
}
</style>
